import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '~/config';

import styles from './UpgradeToUnlock.module.scss';

export const UpgradeToUnlock = () => {
  const { t } = useTranslation('widget');

  const handleContactSales = () =>
    window.open(config.supportUrl, '_blank', 'noopener,noreferrer');

  return (
    <div className={styles.container} data-testid="upgrade-to-unlock">
      <div className={styles.imageContainer}>
        <img
          className={styles.image}
          src="/app/static/images/illustrations/success.png"
          alt=""
        />
      </div>
      <p className={styles.title}>{t('widget:upgradeToUnlock.title')}</p>
      <Button
        className={styles.styledButton}
        variant="primary"
        size="large"
        onClick={handleContactSales}
        label={t('widget:upgradeToUnlock.contactSales')}
      />
    </div>
  );
};
